import { AttachmentPayload } from '@/shared/lib/helpers/payloadHelpers';

import { ServiceFileManager } from '@/helpers/serviceFileManager';

import { UserRequestDraft, UserService } from '@/api/types';

import { MissingPersonExtractMergedSchema } from '../model/types';

import { collectAttachments, generateApplicationAttachment } from './payloadHelpers';

interface Props {
  withAttachments: boolean;
  requestId: UserRequestDraft['id'];
  formData: MissingPersonExtractMergedSchema;
  service: UserService;
  serviceFileManager?: ServiceFileManager;
}

export const generatePayload = async ({
  requestId,
  service,
  formData,
  serviceFileManager,
}: Props): Promise<Record<string, unknown>> => {
  const basePayload = {
    requestId,
    service: {
      id: service.id,
      name: service.name,
      code: service.code,
    },
    missing_person: {
      last_name: formData.missingPerson.lastName,
      first_name: formData.missingPerson.firstName,
      patronymic: formData.missingPerson.middleName,
      birthday: formData.missingPerson.birthday,
      person_status_id: formData.missingPerson.status.id,
      person_status_name: formData.missingPerson.status.label,
    },
    applicant: {
      last_name: formData.applicant.lastName,
      first_name: formData.applicant.firstName,
      patronymic: formData.applicant.middleName,
      sex: formData.applicant.gender.id,
      email: formData.applicant.email,
      phones: formData.applicant.phones,
      rnokpp: formData.applicant.rnokpp,
      resubmitting_request: formData.applicant.resubmittingRequest ?? false,
      ancestral_connection_id: formData.applicant.ancestralConnection.id,
      ancestral_connection_name: formData.applicant.ancestralConnection.label,
      additional_info: formData.applicant.additional_info,
    },
    ...(serviceFileManager?.getSignature() || {}),
    attachments: [...collectAttachments(formData), await generateApplicationAttachment(serviceFileManager)].filter(
      (attach) => !!attach,
    ) as AttachmentPayload[],
    confirm: formData.confirmEnteredDataCorrect,
  };

  return basePayload;
};
